import { render, staticRenderFns } from "./DialogSetup2FA.vue?vue&type=template&id=3e0bc0ae"
import script from "./DialogSetup2FA.vue?vue&type=script&setup=true&lang=js"
export * from "./DialogSetup2FA.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../frontend.kantoor/app/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports